import { App as CapApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { DEEP_LINK_SCHEME } from '@/mobile/constants/mobile';

export type DeepLinkHandler = (path: string, url: string) => void;

/**
 * Parses societyapp://complaints/abc → /complaints/abc
 * Also handles https://host/... App Links.
 */
export function parseDeepLinkUrl(url: string): string | null {
  try {
    if (url.startsWith(`${DEEP_LINK_SCHEME}://`)) {
      const withoutScheme = url.slice(`${DEEP_LINK_SCHEME}://`.length);
      const path = withoutScheme.startsWith('/') ? withoutScheme : `/${withoutScheme}`;
      return path.split('?')[0] || '/';
    }
    const parsed = new URL(url);
    if (parsed.protocol === 'https:' || parsed.protocol === 'http:') {
      return `${parsed.pathname}${parsed.search}` || '/';
    }
  } catch {
    return null;
  }
  return null;
}

export function mapDeepLinkToRoute(path: string): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  // societyapp://complaints/:id
  if (/^\/complaints\/[^/]+/.test(clean)) return clean;
  if (clean === '/complaints' || clean.startsWith('/complaints')) return clean;
  if (clean === '/m/home') return '/dashboard';
  if (clean.startsWith('/m/')) return clean;
  if (clean === '/' || clean === '') return '/dashboard';
  return clean;
}

export async function getLaunchUrl(): Promise<string | null> {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const result = await CapApp.getLaunchUrl();
    return result?.url ?? null;
  } catch {
    return null;
  }
}

export function listenForDeepLinks(handler: DeepLinkHandler): () => void {
  if (!Capacitor.isNativePlatform()) return () => undefined;

  let removed = false;
  let handle: { remove: () => Promise<void> } | null = null;

  void CapApp.addListener('appUrlOpen', (event) => {
    if (removed) return;
    const path = parseDeepLinkUrl(event.url);
    if (path) handler(mapDeepLinkToRoute(path), event.url);
  }).then((h) => {
    handle = h;
    if (removed) void h.remove();
  });

  return () => {
    removed = true;
    void handle?.remove();
  };
}
